import { COMMON_DETAIL } from "@/constants/detail";
import crematoriumDetailType, { crematoriumResponseType } from "types/crematoriumDetailType";
// import jangjiDetailType, { jangjiResponseType } from "types/jangjiDetailType";
import parlorDetailType, { parlorResponseType } from "types/parlorDetailType";
// import parseJangjiName from "./parseJangjiName";

export const optimizeParlorDetail = (parlor: parlorResponseType) => {
  const { pyeong, ...parlorResponse } = parlor;
  const detailValue = pyeong > 0 ? `${Math.floor(pyeong)}평` : "--";

  const detail: parlorDetailType = {
    ...parlorResponse,
    ...COMMON_DETAIL.parlor,
    detailValue: [detailValue],
    images:
      parlor.images && parlor.images.length > 0
        ? parlor.images
        : [`${process.env.NEXT_PUBLIC_CDN_URL}/images/no-image.png`],
  };

  return detail;
};

// export const optimizeJangjiDetail = (jangji: jangjiResponseType) => {
//   const name = parseJangjiName(jangji.name);

//   const detail: jangjiDetailType = {
//     ...jangji,
//     ...COMMON_DETAIL.jangji,
//     name,
//     images: [`${process.env.NEXT_PUBLIC_CDN_URL}/images/estimate/${name}.png`],
//   };

//   return detail;
// };

export const optimizeCrematoriumDetail = (crematorium: crematoriumResponseType) => {
  const { is_inner, ...crematoriumResponse } = crematorium;
  const detailValue = is_inner ? "관내" : "관외";

  const detail: crematoriumDetailType = {
    ...crematoriumResponse,
    ...COMMON_DETAIL.crematorium,
    detailValue: [detailValue],
    images:
      crematorium.images && crematorium.images.length > 0
        ? crematorium.images
        : [`${process.env.NEXT_PUBLIC_CDN_URL}/images/no-image.png`],
  };

  return detail;
};
